module.exports = __webpack_public_path__ + "img/1495129583.eed2bc02.jpg";